module.exports = __webpack_public_path__ + "ad2a171d1b56aadc1bdb5182cecb49d3.png";